export default __webpack_public_path__ + "8949d3f4fbdc2eec5111adba903c3773.svg";